<div class="kt-grid kt-grid--hor kt-grid--root" *ngIf="appLoad && !selfService">
    <app-oauth></app-oauth>
    <div *ngIf="showRouter" class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
        <stg-ngx-left-nav class="alterBg" [menuList]="menuItems" [headerLogo]="logo" [minimizeOnLoad]="true"
            showSubMenuOn="hover"></stg-ngx-left-nav>
        <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">
            <stg-ngx-header [headerLogo]="logo" [profileImageUrl]="profileImageUrl"
                [profileMenuItems]="profileMenuItems">
                <div class="col-sm-6" *ngIf="!disableNotificationIconForOtherPages"
                    style="margin-top: 70%; margin-left: -50%;">
                    <mat-icon class="icon" [matBadge]="badgeCount" matBadgeColor="warn" (click)="showNotificationCount()"
                        [matBadgeHidden]="hidden">
                        notifications
                    </mat-icon>
                </div>
            </stg-ngx-header>
            <app-page-header #pageHeader>
                <app-facility-selector *ngIf="showFacilitySelector" [facilityList]=facilityList>
                </app-facility-selector>
            </app-page-header>
            <div class="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" id="kt_content">
                <div class="kt-container kt-grid__item kt-grid__item--fluid kt-container--fluid">
                    <block-ui>
                        <div *ngIf="loadWithRBAC">
                            <router-outlet></router-outlet>
                        </div>
                    </block-ui>
                </div>
            </div>
            <stg-ngx-footer class="alterBgFooter"></stg-ngx-footer>
        </div>
    </div>

    <div [ngClass]="(path === '/home') ? 'NoMargin' : 'styleMargin'">
        <div class="textStyle" *ngIf="showAuthMsg && !showRouter">
            <div class="loaderAuth"></div>
            <span>Authorization In Progress</span>
            <!-- </div><div *ngIf="showRouter"><router-outlet></router-outlet></div> -->
        </div>

    </div>
</div>
<div *ngIf="appLoad && selfService">
    <div class="bodycontainer bodyContent">
        <div class="row" id="content" [ngClass]='{"pageContent":prelogin}'>
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
<div *ngIf="unauthorized && !appLoad">
    <router-outlet></router-outlet>
</div>
<!-- <div *ngIf="appLoad && !selfService && loadWithRBAC && loadWithChatBot">
    <img 
      src="assets/images/assistant-human.png" 
      alt="Chat Assistant" 
      class="chat-fab"
      (click)="toggleChat()" />
    <div class="chat-content" *ngIf="showChat">
      <iframe 
        src="https://copilotstudio.preview.microsoft.com/environments/4b45198c-0d5a-eaf1-b995-492393062206/bots/cr08e_morrisonDietManualAssistant/webchat?__version__=2" 
        frameborder="0" 
        style="width: 100%; height: 100%;">
      </iframe>
    </div>
  </div> -->

  <div 
  *ngIf="appLoad && !selfService && loadWithRBAC && loadWithChatBot && loadChatbotForActive"
  class="chat-draggable"
  [ngStyle]="{'top.px': chatPosition.top, 'left.px': chatPosition.left}"
  (mousedown)="startDrag($event)"
>
  <img 
    src="assets/images/assistant-human.png" 
    alt="Chat Assistant" 
    class="chat-fab"
    (click)="toggleChat()" 
  />
  <div class="chat-content" *ngIf="showChat">
    <iframe 
      src="https://copilotstudio.preview.microsoft.com/environments/19f16a23-6894-e396-8ffc-3424f858f11c/bots/cr08e_morrisonDietManualAssistant/webchat?__version__=2" 
      frameborder="0" 
      style="width: 100%; height: 100%;">
    </iframe>
  </div>
</div>

<!-- <div *ngIf="appLoad && !selfService && loadWithRBAC && loadWithChatBot" class="agentHolder">
    <button style="rotate: 90deg;margin: 5px;" type="button" class="collapsible" (click)="toggleChat()">Morrison Diet Manual Assistant Preview</button>
    <div class="content">
      <iframe src="https://copilotstudio.preview.microsoft.com/environments/4b45198c-0d5a-eaf1-b995-492393062206/bots/cr08e_morrisonDietManualAssistant/webchat?__version__=2" frameborder="0" style="width: 100%; height: 100%;"></iframe>
    </div>
</div> -->